import React from "react";

const testimonials = [
  {
    name: "Abishek",
    feedback: "Unito transformed the way I practice DSA. The progress tracking and structured learning kept me motivated!",
    role: "Software Engineer Intern",
  },
  {
    name: "Rudra",
    feedback: "The best platform to stay consistent with coding! The UI is clean, and the challenges are well-organized.",
    role: "Competitive Programmer",
  },
  {
    name: "Adithya",
    feedback: "Unito helped me land my first internship. The structured learning and AI support were game-changers!",
    role: "CS Student & Problem Solver",
  },
];

function Testimonials() {
  return (
    <div className="bg-[#222831] py-16 px-6 flex flex-col items-center text-center">
      <h1 className="text-4xl font-bold text-white mb-6 bg-[#222831]">💬 <span className="bg-gradient-to-r from-violet-500 to-red-500 text-transparent bg-clip-text">What Our Users Say</span></h1>
      <p className="text-gray-300 mb-12 max-w-2xl">
        See how Unito helps students and professionals stay consistent and improve their skills.
      </p>
      
      <div className="flex flex-wrap justify-center gap-8 max-w-5xl">
        {testimonials.map((testimonial, index) => ( 
          <div
            key={index}
            className="backdrop-blur-lg bg-white/10 p-6 rounded-xl text-white shadow-lg 
            hover:scale-105 transition-transform duration-300 w-[320px] md:w-[350px]"
          >
            <p className="text-gray-200 italic">“{testimonial.feedback}”</p>
            <h2 className="text-lg font-semibold mt-4">{testimonial.name}</h2>
            <p className="text-sm text-gray-400">{testimonial.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Testimonials;
